import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import './index.css';

// Lazy loaded pages
const Home = lazy(() => import('./pages/Home'));
const Solutions = lazy(() => import('./pages/Solutions'));
const Insights = lazy(() => import('./pages/Insights'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Careers = lazy(() => import('./pages/Careers'));
const Mou = lazy(() => import('./pages/Mou'));
const Gallery = lazy(() => import('./pages/Gallery'));
const Events = lazy(() => import('./pages/Events'));

const ResourceTeam = lazy(() => import('./pages/ResourceTeam'));
// What We Offer
const ResearchPublication = lazy(() => import('./pages/ResearchPublication'));
const AcademicCounselling = lazy(() => import('./pages/AcademicCounselling'));
const AGEduhubFoundation = lazy(() => import('./pages/Foundation'));
const BookPublication = lazy(() => import('./pages/BookPublication'));
const NeetCounselling = lazy(() => import('./pages/NeetCounselling'));
const PhDGuidance = lazy(() => import('./pages/PhDGuidance'));
const InstitutionalAffiliation = lazy(() => import('./pages/InstitutionalAffiliation'));
const TrainingsAndDevelopment = lazy(() => import('./pages/TrainingsAndDevelopment'));
const Donation = lazy(() => import('./pages/Donation'));


// Insight detail pages
const SuccessStrategies = lazy(() => import('./pages/insights/SuccessStrategies'));
const EnrollmentTrends = lazy(() => import('./pages/insights/EnrollmentTrends'));
const LeadershipInsights = lazy(() => import('./pages/insights/LeadershipInsights'));
const DigitalTransformation = lazy(() => import('./pages/insights/DigitalTransformation'));
const DataPrivacy = lazy(() => import('./pages/insights/DataPrivacy'));
const AIClassroom = lazy(() => import('./pages/insights/AIClassroom'));

const NotFound = lazy(() => import('./pages/NotFound'));

// Rotating logo loader (replace with your actual logo path)
const LoadingSpinner = () => (
  <div className="flex items-center justify-center h-screen bg-white">
    <img
      src="/logo152.png"
      alt="Loading..."
      className="w-16 h-16 animate-spin"
    />
  </div>
);

function App() {
  return (
    <Router>
      <Layout>
        <Suspense fallback={<LoadingSpinner />}>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/mou" element={<Mou />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/events" element={<Events />} />

            {/* What We Offer */}
            <Route path="/research-publication" element={<ResearchPublication />} />
            <Route path="/academic-counselling" element={<AcademicCounselling />} />
            <Route path="/ag-eduhub-foundation" element={<AGEduhubFoundation />} />
            
            <Route path="/book-publication" element={<BookPublication />} />
            <Route path="/neet-counselling" element={<NeetCounselling />} />
            <Route path="/phd-guidance" element={<PhDGuidance />} />
            <Route path="/institutional-affiliation" element={<InstitutionalAffiliation />} />
           
            <Route path="/resource-team" element={<ResourceTeam />} />
            <Route path="/trainings-and-development" element={<TrainingsAndDevelopment />} />
            <Route path="/donations" element={<Donation />} />



            {/* Insight Detail Routes */}
            <Route path="/insights/success-strategies" element={<SuccessStrategies />} />
            <Route path="/insights/enrollment-trends" element={<EnrollmentTrends />} />
            <Route path="/insights/leadership-2025" element={<LeadershipInsights />} />
            <Route path="/insights/digital-transformation" element={<DigitalTransformation />} />
            <Route path="/insights/data-privacy" element={<DataPrivacy />} />
            <Route path="/insights/ai-classroom" element={<AIClassroom />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
}

export default App;
